import {match} from 'ts-pattern';

import {always, isNil} from 'ramda';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

export const getMazdaWarrantyTypeLabel = (warrantyType: string | Nullish) =>
  match(warrantyType)
    .when(isNil, always(undefined))
    .with('basic_warranty', always(i18n.t('entity.orderIntegration.labels.warrantyTypeBasic')))
    .with(
      'predelivery_inspection',
      always(i18n.t('entity.orderIntegration.labels.warrantyTypePredeliveryInspection'))
    )
    .with(
      'part_warranty',
      always(i18n.t('entity.orderIntegration.labels.warrantyTypePartWarranty'))
    )
    .with(
      'repeated_repair',
      always(i18n.t('entity.orderIntegration.labels.warrantyTypeRepeatedRepair'))
    )
    .otherwise((value) => value);
